import { render, staticRenderFns } from "./Detail2.vue?vue&type=template&id=c17334d0&scoped=true"
import script from "./Detail2.vue?vue&type=script&lang=js"
export * from "./Detail2.vue?vue&type=script&lang=js"
import style0 from "./Detail2.vue?vue&type=style&index=0&id=c17334d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17334d0",
  null
  
)

export default component.exports